(() => {
  'use strict';
  if (window.onairReviewLinksBound) return;
  window.onairReviewLinksBound = true;
  const destination = document.currentScript?.dataset.onairReviewsUrl || '/#onair-owner-reviews';
  function repair(link) {
    if (!link?.matches('a[href*="/pages/reviews"]')) return;
    try {
      const url = new URL(link.href, location.href);
      if (url.origin === location.origin && url.pathname.endsWith('/pages/reviews')) link.setAttribute('href', destination);
    } catch { /* Leave unrelated or invalid links unchanged. */ }
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    repair(root);
    root.querySelectorAll('a[href*="/pages/reviews"]').forEach(repair);
  }
  function init() {
    scan(document.body);
    new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(scan));
    }).observe(document.body, {subtree:true, childList:true});
    for (const name of ['click','pointerdown','focusin']) document.addEventListener(name, event => repair(event.target.closest?.('a')), true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
